import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

import { watch } from "vue";
import { useLocalStorage } from "@vueuse/core";

import { useAsync } from "@/use/useAsync";
import { useOperations } from "@/use/useOperations";
import { useStore } from "@/use/useStore";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiIcon from "@/plugins/ui/components/icon/UiIcon.vue";

import UiCollapse from "@/components/ui/UiCollapse.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";

import OperationCell from "@/components/operations/OperationCell.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LastOperations',
  setup(__props) {

const { currentUser } = useStore();
const { operations, fetchOperations } = useOperations();

const fetchData = useAsync(() => fetchOperations({ limit: "5" }), true);

const expanded = useLocalStorage("expand-last-operations", true);

watch(() => currentUser.value?.id, fetchData.execute);

return (_ctx: any,_cache: any) => {
  return (_unref(operations).length != 0)
    ? (_openBlock(), _createBlock(UiGroup, _normalizeProps(_mergeProps({ key: 0 }, _ctx.$attrs)), {
        default: _withCtx(() => [
          _createVNode(UiCollapse, {
            modelValue: _unref(expanded),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(expanded) ? (expanded).value = $event : null))
          }, {
            header: _withCtx(() => [
              _createVNode(UiHeader, { title: "Последние операции" }, {
                right: _withCtx(() => [
                  _createVNode(UiIcon, {
                    size: 18,
                    class: _normalizeClass([{ 'transform-gpu rotate-180': _unref(expanded) }, "transition duration-200"]),
                    icon: "ChevronDown"
                  }, null, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(UiCard, null, {
                default: _withCtx(() => [
                  _createVNode(UiSuspense, {
                    failure: _unref(fetchData).isFailure.value,
                    pending: _unref(fetchData).isPending.value,
                    success: _unref(fetchData).isSuccess.value
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operations), (operation) => {
                        return (_openBlock(), _createBlock(OperationCell, {
                          key: operation.id,
                          operation: operation
                        }, null, 8, ["operation"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["failure", "pending", "success"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 16))
    : _createCommentVNode("", true)
}
}

})